/* Item Files Store */

import {
    uploadItemFile,
    createItemFile,
    fetchUploadedItemFiles,
    downloadUploadedItemFile,
    updateUploadedItemFile
} from '@/api'

const state = {
    uploaded: [],
    processed: []
}

const actions = {
    uploadFile (context, file) {
        return uploadItemFile(file)
    },
    createItemFile (context, payload) {
        return createItemFile(payload)
    },
    fetchUploadedItemFiles (context) {
        return fetchUploadedItemFiles().then(response => {
            context.commit('setUploadedItemFiles', response.data)
        })
    },
    downloadUploadedItemFile (context, key) {
        return downloadUploadedItemFile(key)
    },
    updateUploadedItemFile (context, payload) {
        return updateUploadedItemFile(payload)
    }
}

const mutations = {
    setUploadedItemFiles (state, payload) {

        // Get the contents from the response.
        state.uploaded = payload['S3']['Contents']
    }
}

const getters = {
    getUploadedItemFiles (state) {
        return state.uploaded
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}